
export default {
  MobileLeaderboard: [320, 50],
  MediumRectangle: [300, 250],
  Leaderboard: [728, 90],
};
